// Single source of truth for the primary navigation links.
// Rendered by Title.js (desktop bar + mobile menu).
export const NAV = [
  { to: "/mission", label: "Mission" },
  { to: "/instrument", label: "Instruments" },
  { to: "/telescopes", label: "Telescopes" },
  { to: "/survey", label: "Survey" },
  { to: "/visualizations", label: "Visualizations" },
  { to: "/science-book", label: "Science Book" },
  { to: "/team", label: "Team" },
];
